import confetti from "canvas-confetti";

const KEY = "rl_ticket_celebrated";
const seen = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };

/* Short synthesized win chime — no audio asset needed. */
const chime = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext; if (!Ctx) return;
    const ctx = new Ctx(); const t0 = ctx.currentTime;
    [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = "triangle"; o.frequency.value = f;
      g.gain.setValueAtTime(0, t0 + i * 0.09); g.gain.linearRampToValueAtTime(0.25, t0 + i * 0.09 + 0.02); g.gain.exponentialRampToValueAtTime(0.001, t0 + i * 0.09 + 0.45);
      o.connect(g).connect(ctx.destination); o.start(t0 + i * 0.09); o.stop(t0 + i * 0.09 + 0.5);
    });
    setTimeout(() => ctx.close().catch(() => {}), 1500);
  } catch {}
};

/* Confetti + chime once per winning ticket; returns false if already celebrated. */
export const celebrateTicket = (id, el) => {
  const list = seen();
  if (list.includes(id)) return false;
  localStorage.setItem(KEY, JSON.stringify([...list, id].slice(-200)));
  const r = el?.getBoundingClientRect?.();
  const origin = r ? { x: (r.left + r.width / 2) / window.innerWidth, y: (r.top + r.height / 2) / window.innerHeight } : { y: 0.6 };
  const colors = ["#FFC107", "#FFE082", "#10B981", "#2563EB", "#ffffff"];
  confetti({ particleCount: 90, spread: 75, startVelocity: 38, origin, colors });
  setTimeout(() => confetti({ particleCount: 50, spread: 110, scalar: 0.8, origin, colors }), 250);
  chime();
  return true;
};
